<div class="disclaimer-content" [ngClass]="{ 'decrease-readability': hideALittle(), chatbot: isChatbot() }">
	<span class="h5" [translate]="message()"></span>
</div>
